const BtnPrimary =(props) =>{
const classes = "flex w-full justify-center items-center font-lato font-medium !text-[14px] leading-[21px] tracking-[0%] text text-white px-[18px] py-4 h-[41px] min-h-[41px] bg-[#FF8E1C] border border-[#FFF4E5]/100 shadow-[0_2px_5px_#FFF4E5] rounded-[8px] hover:bg-[#e57d12] focus:bg-[#FF8E1C] duration-100 primary-btn " + props.className;    return(
        <button className={classes} disabled={props.disabled} type={props.type || "button"}
        onClick={props.onClick}>
            {props.children}
        </button>
    )
}

export default BtnPrimary